<template>
<breadCrumbs title="Pricing" main="Ecommerce" title1="Pricing" />
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header pb-0">
                    <h3>Simple Pricing Card</h3>
                </div>
                <div class="card-body row pricing-content">
                    <div class="col-xxl-3 col-sm-6" v-for="(item,index) in menu" :key="index">
                        <div class="card text-center pricing-simple">
                            <div class="card-body">
                                <h3>{{item.title}}</h3>
                                <h1>${{item.price}}</h1>
                                <h6 class="mb-0">Standard Price</h6>
                            </div><a class="btn btn-lg btn-primary btn-block" href="javascript:void(0)">
                                <h5 class="mb-0">Purchase</h5>
                            </a>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header pb-0">
                    <h3>Pricing</h3>
                </div>
                <div class="card-body row pricing-content">
                    <div class="col-lg-3 col-sm-6" v-for="(item,index) in menu1" :key="index">
                        <div class="pricing-block card text-center" >
                            <div class="pricing-header">
                                <h2>{{item.title}}</h2>
                                <div class="price-box">
                                    <div>
                                        <h3>${{item.price}}</h3>
                                        <p>/ month</p>
                                    </div>
                                </div>
                            </div>
                            <div class="pricing-list">
                                <ul class="pricing-inner">
                                    <li>
                                        <h6>{{item.disk}}50GB<span> Disk Space</span></h6>
                                    </li>
                                    <li>
                                        <h6>{{item.email}}50<span> Email Accounts</span></h6>
                                    </li>
                                    <li>
                                        <h6>{{item.band}}50GB<span> Bandwidth</span></h6>
                                    </li>
                                    <li>
                                        <h6>{{item.subdomain}}10<span> Subdomains</span></h6>
                                    </li>
                                    <li>
                                        <h6>{{item.domain}}15<span> Domains</span></h6>
                                    </li>
                                </ul>
                                <button class="btn btn-primary btn-lg" type="button" data-original-title="btn btn-primary btn-lg" title="">Subscribe</button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
import {data,data1} from '../../../data/pricing.json'
export default {
    name: 'pricingView',
    data(){
        return{
            menu: data,
            menu1: data1
        }
    }
}
</script>
